export const translationLanguages = {
    de: 'Deutsch',
    en: 'Englisch',
    pl: 'Polnisch',
    ru: 'Russisch',
};
